export const ATTESTATION_LANGUAGES = {
    'en': 'English',
    'fr': 'French',
    'es': 'Spanish',
}